// components
import BetaTag from "components/atoms/BetaTag";
import { ConstructionIcon, EnergyIcon, EquipmentIcon, WarningCountIcon } from "components/atoms/Icon";
import { Paragraph } from "components/atoms/Typography";
import { BuildingSidebarTab } from "utils/enums";

interface BuildingSidebarTabsProps {
    onClick: (view: BuildingSidebarTab) => void;
    view: BuildingSidebarTab;
    dataCoverageWarnings?: DataCoverageWarningsList;
    hasEquipmentSizeAndYear?: boolean;
    equipmentDataUploaded?: boolean;
}

function BuildingSidebarTabs({
    onClick,
    view,
    dataCoverageWarnings,
    hasEquipmentSizeAndYear,
    equipmentDataUploaded,
}: BuildingSidebarTabsProps) {
    return (
        <div className="building-sidebar-tabs">
            <button
                type="button"
                id="building-profile-construction-tab"
                className="building-sidebar-tabs__button"
                onClick={() => onClick(BuildingSidebarTab.construction)}
                style={view === BuildingSidebarTab.construction ? { color: "#EB03AD", fill: "#EB03AD" } : undefined}
            >
                <div className="construction-icon" style={{ position: "relative" }}>
                    <ConstructionIcon
                        color={view === BuildingSidebarTab.construction ? "var(--audette-pink)" : undefined}
                    />
                </div>
                <div className="building-sidebar-tabs__title-with-tag">
                    <Paragraph>Construction</Paragraph>
                </div>
            </button>
            <button
                id="building-profile-equipment-tab"
                type="button"
                className="building-sidebar-tabs__button"
                onClick={() => onClick(BuildingSidebarTab.equipment)}
                style={view === BuildingSidebarTab.equipment ? { color: "#EB03AD", fill: "#EB03AD" } : undefined}
            >
                <div className="equipment-icon" style={{ position: "relative" }}>
                    <EquipmentIcon />
                    {(dataCoverageWarnings?.equipmentWarning ||
                        (!hasEquipmentSizeAndYear && equipmentDataUploaded)) && <Warning type="equipment" />}
                </div>
                <div className="building-sidebar-tabs__title-with-tag">
                    <Paragraph>Equipment</Paragraph>
                </div>
            </button>
            <button
                type="button"
                id="building-profile-energy-tab"
                className="building-sidebar-tabs__button"
                onClick={() => onClick(BuildingSidebarTab.energy)}
                style={view === BuildingSidebarTab.energy ? { color: "#EB03AD", fill: "#EB03AD" } : undefined}
            >
                <div className="energy-icon" style={{ position: "relative" }}>
                    <EnergyIcon />
                    {dataCoverageWarnings?.energyWarning && <Warning type="energy" />}
                </div>
                <div className="building-sidebar-tabs__title-with-tag">
                    <Paragraph>Energy</Paragraph>
                    {view === BuildingSidebarTab.energy && <BetaTag />}
                </div>
            </button>
        </div>
    );
}

interface WarningProps {
    type: "energy" | "equipment";
}

function Warning({ type }: WarningProps) {
    return (
        <div data-testid={`warning-icon-${type}`}>
            <WarningCountIcon
                style={{
                    position: "absolute",
                    top: "-8.48px",
                    left: "11px",
                }}
            />
        </div>
    );
}

export default BuildingSidebarTabs;
